/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ContractorPaymentDto } from '../models';
// @ts-ignore
import { ContractorPaymentDtoPaginatedList } from '../models';
// @ts-ignore
import { ContractorPaymentsSummaryDto } from '../models';
// @ts-ignore
import { CreateContractorPaymentCommand } from '../models';
// @ts-ignore
import { MarkContractorPaymentAsPaidCommand } from '../models';
// @ts-ignore
import { ProjectPaymentSummaryDto } from '../models';
// @ts-ignore
import { UpdateContractorPaymentCommand } from '../models';
/**
 * ContractorPaymentsApi - axios parameter creator
 * @export
 */
export const ContractorPaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} contractorId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [isPaid] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {number} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsGet: async (contractorId: number, pageNumber?: number, pageSize?: number, isPaid?: boolean, fromDate?: string, toDate?: string, projectId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsGet', 'contractorId', contractorId)
            const localVarPath = `/api/contractors/{contractorId}/payments`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (isPaid !== undefined) {
                localVarQueryParameter['isPaid'] = isPaid;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsIdDelete: async (contractorId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsIdDelete', 'contractorId', contractorId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsIdDelete', 'id', id)
            const localVarPath = `/api/contractors/{contractorId}/payments/{id}`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {MarkContractorPaymentAsPaidCommand} [markContractorPaymentAsPaidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsIdMarkAsPaidPost: async (contractorId: number, id: number, markContractorPaymentAsPaidCommand?: MarkContractorPaymentAsPaidCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsIdMarkAsPaidPost', 'contractorId', contractorId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsIdMarkAsPaidPost', 'id', id)
            const localVarPath = `/api/contractors/{contractorId}/payments/{id}/mark-as-paid`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markContractorPaymentAsPaidCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {UpdateContractorPaymentCommand} [updateContractorPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsIdPut: async (contractorId: number, id: number, updateContractorPaymentCommand?: UpdateContractorPaymentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsIdPut', 'contractorId', contractorId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsIdPut', 'id', id)
            const localVarPath = `/api/contractors/{contractorId}/payments/{id}`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContractorPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsOverdueGet: async (contractorId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsOverdueGet', 'contractorId', contractorId)
            const localVarPath = `/api/contractors/{contractorId}/payments/overdue`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {CreateContractorPaymentCommand} [createContractorPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsPost: async (contractorId: number, createContractorPaymentCommand?: CreateContractorPaymentCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsPost', 'contractorId', contractorId)
            const localVarPath = `/api/contractors/{contractorId}/payments`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContractorPaymentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsProjectProjectIdGet: async (contractorId: number, projectId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsProjectProjectIdGet', 'contractorId', contractorId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsProjectProjectIdGet', 'projectId', projectId)
            const localVarPath = `/api/contractors/{contractorId}/payments/project/{projectId}`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsSummaryGet: async (contractorId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorId' is not null or undefined
            assertParamExists('apiContractorsContractorIdPaymentsSummaryGet', 'contractorId', contractorId)
            const localVarPath = `/api/contractors/{contractorId}/payments/summary`
                .replace(`{${"contractorId"}}`, encodeURIComponent(String(contractorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorPaymentsApi - functional programming interface
 * @export
 */
export const ContractorPaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorPaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} contractorId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [isPaid] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {number} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsGet(contractorId: number, pageNumber?: number, pageSize?: number, isPaid?: boolean, fromDate?: string, toDate?: string, projectId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorPaymentDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsGet(contractorId, pageNumber, pageSize, isPaid, fromDate, toDate, projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsIdDelete(contractorId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsIdDelete(contractorId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {MarkContractorPaymentAsPaidCommand} [markContractorPaymentAsPaidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsIdMarkAsPaidPost(contractorId: number, id: number, markContractorPaymentAsPaidCommand?: MarkContractorPaymentAsPaidCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsIdMarkAsPaidPost(contractorId, id, markContractorPaymentAsPaidCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {UpdateContractorPaymentCommand} [updateContractorPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsIdPut(contractorId: number, id: number, updateContractorPaymentCommand?: UpdateContractorPaymentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsIdPut(contractorId, id, updateContractorPaymentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsOverdueGet(contractorId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractorPaymentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsOverdueGet(contractorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {CreateContractorPaymentCommand} [createContractorPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsPost(contractorId: number, createContractorPaymentCommand?: CreateContractorPaymentCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsPost(contractorId, createContractorPaymentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsProjectProjectIdGet(contractorId: number, projectId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPaymentSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsProjectProjectIdGet(contractorId, projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiContractorsContractorIdPaymentsSummaryGet(contractorId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContractorPaymentsSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiContractorsContractorIdPaymentsSummaryGet(contractorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContractorPaymentsApi - factory interface
 * @export
 */
export const ContractorPaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorPaymentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} contractorId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {boolean} [isPaid] 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {number} [projectId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsGet(contractorId: number, pageNumber?: number, pageSize?: number, isPaid?: boolean, fromDate?: string, toDate?: string, projectId?: number, options?: any): AxiosPromise<ContractorPaymentDtoPaginatedList> {
            return localVarFp.apiContractorsContractorIdPaymentsGet(contractorId, pageNumber, pageSize, isPaid, fromDate, toDate, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsIdDelete(contractorId: number, id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorsContractorIdPaymentsIdDelete(contractorId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {MarkContractorPaymentAsPaidCommand} [markContractorPaymentAsPaidCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsIdMarkAsPaidPost(contractorId: number, id: number, markContractorPaymentAsPaidCommand?: MarkContractorPaymentAsPaidCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorsContractorIdPaymentsIdMarkAsPaidPost(contractorId, id, markContractorPaymentAsPaidCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} id 
         * @param {UpdateContractorPaymentCommand} [updateContractorPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsIdPut(contractorId: number, id: number, updateContractorPaymentCommand?: UpdateContractorPaymentCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiContractorsContractorIdPaymentsIdPut(contractorId, id, updateContractorPaymentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsOverdueGet(contractorId: number, options?: any): AxiosPromise<Array<ContractorPaymentDto>> {
            return localVarFp.apiContractorsContractorIdPaymentsOverdueGet(contractorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {CreateContractorPaymentCommand} [createContractorPaymentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsPost(contractorId: number, createContractorPaymentCommand?: CreateContractorPaymentCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiContractorsContractorIdPaymentsPost(contractorId, createContractorPaymentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsProjectProjectIdGet(contractorId: number, projectId: number, options?: any): AxiosPromise<ProjectPaymentSummaryDto> {
            return localVarFp.apiContractorsContractorIdPaymentsProjectProjectIdGet(contractorId, projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} contractorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiContractorsContractorIdPaymentsSummaryGet(contractorId: number, options?: any): AxiosPromise<ContractorPaymentsSummaryDto> {
            return localVarFp.apiContractorsContractorIdPaymentsSummaryGet(contractorId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiContractorsContractorIdPaymentsGet operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsGetRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsGet
     */
    readonly contractorId: number

    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {boolean}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsGet
     */
    readonly isPaid?: boolean

    /**
     * 
     * @type {string}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsGet
     */
    readonly toDate?: string

    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsGet
     */
    readonly projectId?: number
}

/**
 * Request parameters for apiContractorsContractorIdPaymentsIdDelete operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsIdDeleteRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdDelete
     */
    readonly contractorId: number

    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiContractorsContractorIdPaymentsIdMarkAsPaidPost operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsIdMarkAsPaidPostRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsIdMarkAsPaidPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdMarkAsPaidPost
     */
    readonly contractorId: number

    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdMarkAsPaidPost
     */
    readonly id: number

    /**
     * 
     * @type {MarkContractorPaymentAsPaidCommand}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdMarkAsPaidPost
     */
    readonly markContractorPaymentAsPaidCommand?: MarkContractorPaymentAsPaidCommand
}

/**
 * Request parameters for apiContractorsContractorIdPaymentsIdPut operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsIdPutRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdPut
     */
    readonly contractorId: number

    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateContractorPaymentCommand}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsIdPut
     */
    readonly updateContractorPaymentCommand?: UpdateContractorPaymentCommand
}

/**
 * Request parameters for apiContractorsContractorIdPaymentsOverdueGet operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsOverdueGetRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsOverdueGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsOverdueGet
     */
    readonly contractorId: number
}

/**
 * Request parameters for apiContractorsContractorIdPaymentsPost operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsPostRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsPost
     */
    readonly contractorId: number

    /**
     * 
     * @type {CreateContractorPaymentCommand}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsPost
     */
    readonly createContractorPaymentCommand?: CreateContractorPaymentCommand
}

/**
 * Request parameters for apiContractorsContractorIdPaymentsProjectProjectIdGet operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsProjectProjectIdGetRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsProjectProjectIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsProjectProjectIdGet
     */
    readonly contractorId: number

    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsProjectProjectIdGet
     */
    readonly projectId: number
}

/**
 * Request parameters for apiContractorsContractorIdPaymentsSummaryGet operation in ContractorPaymentsApi.
 * @export
 * @interface ContractorPaymentsApiApiContractorsContractorIdPaymentsSummaryGetRequest
 */
export interface ContractorPaymentsApiApiContractorsContractorIdPaymentsSummaryGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractorPaymentsApiApiContractorsContractorIdPaymentsSummaryGet
     */
    readonly contractorId: number
}

/**
 * ContractorPaymentsApi - object-oriented interface
 * @export
 * @class ContractorPaymentsApi
 * @extends {BaseAPI}
 */
export class ContractorPaymentsApi extends BaseAPI {
    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsGet(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsGetRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsGet(requestParameters.contractorId, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.isPaid, requestParameters.fromDate, requestParameters.toDate, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsIdDelete(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsIdDeleteRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsIdDelete(requestParameters.contractorId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsIdMarkAsPaidPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsIdMarkAsPaidPost(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsIdMarkAsPaidPostRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsIdMarkAsPaidPost(requestParameters.contractorId, requestParameters.id, requestParameters.markContractorPaymentAsPaidCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsIdPut(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsIdPutRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsIdPut(requestParameters.contractorId, requestParameters.id, requestParameters.updateContractorPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsOverdueGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsOverdueGet(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsOverdueGetRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsOverdueGet(requestParameters.contractorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsPost(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsPostRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsPost(requestParameters.contractorId, requestParameters.createContractorPaymentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsProjectProjectIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsProjectProjectIdGet(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsProjectProjectIdGetRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsProjectProjectIdGet(requestParameters.contractorId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContractorPaymentsApiApiContractorsContractorIdPaymentsSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractorPaymentsApi
     */
    public apiContractorsContractorIdPaymentsSummaryGet(requestParameters: ContractorPaymentsApiApiContractorsContractorIdPaymentsSummaryGetRequest, options?: AxiosRequestConfig) {
        return ContractorPaymentsApiFp(this.configuration).apiContractorsContractorIdPaymentsSummaryGet(requestParameters.contractorId, options).then((request) => request(this.axios, this.basePath));
    }
}
